import { useQueryClient, useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

// constants
import { BaseError } from '../../helpers/BaseError';

import {
    FormulaDetailModel,
    FormulaDraftPayloadModel,
} from '../../models/formula.model';

// services
import API from '../../services/api';

// hooks
import useAnalytics from '../helper/useAnalytics';
import formulaKeys from './_queryKeys';

export default function useFormulaDraft(id: number) {
    const queryClient = useQueryClient();

    const { track } = useAnalytics();

    return useMutation<
        AxiosResponse<FormulaDetailModel>,
        BaseError,
        FormulaDraftPayloadModel
    >({
        mutationFn: (payload?: FormulaDraftPayloadModel) =>
            API.draftFormula(id, payload),

        onSuccess: ({ data }) => {
            track('formula_toggled_to_draft', {
                formula_id: data.id,
            });
            queryClient.setQueryData(formulaKeys.formulaById(id), data);
            queryClient.invalidateQueries({
                queryKey: formulaKeys.all,
            });
        },
    });
}
